var map = {
	"./NavLogo.svg": 6,
	"./icons/email.png": 16,
	"./icons/github.svg": 7,
	"./icons/linkedin.svg": 8,
	"./icons/location.png": 17,
	"./icons/mobile.png": 18,
	"./landing/about.png": 19,
	"./landing/hero.png": 20,
	"./projects/bbq.jpg": 21,
	"./projects/ecommerce.jpg": 22,
	"./projects/games.jpg": 23,
	"./projects/learning.jpg": 24,
	"./projects/netflix.jpg": 25,
	"./projects/package.jpg": 26,
	"./projects/sns.jpg": 27,
	"./projects/todo.jpg": 28,
	"./projects/vegan.jpg": 29,
	"./screenshots/ecom.png": 30,
	"./screenshots/games.png": 31,
	"./screenshots/lms.png": 32,
	"./screenshots/netflix.png": 33,
	"./screenshots/parceltracker.png": 34,
	"./screenshots/sns.png": 35,
	"./screenshots/todo.png": 36,
	"./screenshots/vegan.png": 37,
	"./skills/code.svg": 38,
	"./skills/codepen.svg": 39,
	"./skills/css.svg": 40,
	"./skills/design.svg": 41,
	"./skills/docker.svg": 42,
	"./skills/dribbble.svg": 43,
	"./skills/figma.svg": 44,
	"./skills/firebase.svg": 45,
	"./skills/gatsby.svg": 46,
	"./skills/git.svg": 47,
	"./skills/github.svg": 48,
	"./skills/html5.svg": 49,
	"./skills/html55.svg": 50,
	"./skills/java.svg": 51,
	"./skills/javascript.svg": 52,
	"./skills/jest.svg": 53,
	"./skills/react.svg": 54,
	"./skills/reactTesting.svg": 55,
	"./skills/recoil.svg": 56,
	"./skills/scrum.svg": 57,
	"./skills/typescript.svg": 58
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 15;